module.exports = __webpack_public_path__ + "static/scrumgoals-8d0de375b3bfe974331c030d7c406da5.png";